import React from "react";
import PropTypes from "prop-types";
import { StyledList, StyledListItem, StyledListText } from "./styles";

const Menu = props => {
  const { handleCurrentStep, currentStep } = props;

  return (
    <React.Fragment>
      <StyledList component="nav" aria-label="Secondary mailbox folders">
        <StyledListItem className={currentStep === "forecast" ? "active-link" : ""} button onClick={() => handleCurrentStep('forecast')}>
          <StyledListText primary="Forecast" />
        </StyledListItem>
        <StyledListItem className={currentStep === "product" ? "active-link" : ""} button onClick={() => handleCurrentStep('product')}>
          <StyledListText primary="Product" />
        </StyledListItem>
      </StyledList>
    </React.Fragment>
  );
};


Menu.propTypes = {
  handleCurrentStep: PropTypes.func,
  currentStep: PropTypes.string
};

export default Menu;
